// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoCard_card__aWcER {
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.InfoCard_cardInner__SMN\\+y {
  border-radius: 20px;
  background: #2b0010;
  box-shadow: 0px 3px 16px 0px rgb(107 18 63);
  padding: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: relative;
  width: 100%;
  max-width: 500px;
  border: 2px solid #e868a8;
}
.InfoCard_login__Hvvpx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #a65b85;
  padding-bottom: 8px;
  margin-bottom: 16px;
}
.InfoCard_loginNumber__y3\\+Iu {
}
.InfoCard_loginNumber__y3\\+Iu p {
  color: #ffffff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.InfoCard_loginNumber__y3\\+Iu span {
  color: #ffffff;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.InfoCard_loginChange__svhvW {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.InfoCard_loginChange__svhvW span {
  color: #ffffff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.InfoCard_loginChange__svhvW img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.InfoCard_title__zxlDV {
  color: #ffffff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.InfoCard_signIn__0IgU6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  gap: 16px;
  margin-top: 8px;
}
.InfoCard_signIn__0IgU6 p {
  color: #ffffff;
  text-align: right;
  /* font-family: "Yekan Bakh FaNum"; */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.InfoCard_tara__-oj\\+g {
  border-radius: 12px;
  background: #480e23;
  padding: 16px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.InfoCard_taraInfo__mIWr3 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 6px;
}
.InfoCard_taraInfo__mIWr3 p {
  color: #fff;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.InfoCard_taraInfo__mIWr3 span {
  font-weight: 600;
}
.InfoCard_taraInfo__mIWr3 img {
}
.InfoCard_taraLink__Acr9G {
  border-radius: 12px;
  border: 1px solid #19b16a;
  background: #fff;
  display: flex;
  padding: 10px 4px 10px 0px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  align-self: stretch;
}
.InfoCard_taraLink__Acr9G span {
  color: #19b16a;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
@media screen and (min-width: 1000px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoCard/InfoCard.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;AACA;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;AACA;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAEhB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA","sourcesContent":[".card {\n  padding: 0 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.cardInner {\n  border-radius: 20px;\n  background: #2b0010;\n  box-shadow: 0px 3px 16px 0px rgb(107 18 63);\n  padding: 16px;\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  border: 2px solid #e868a8;\n}\n.login {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid #a65b85;\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n}\n.loginNumber {\n}\n.loginNumber p {\n  color: #ffffff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.loginNumber span {\n  color: #ffffff;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.loginChange {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.loginChange span {\n  color: #ffffff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.loginChange img {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n.title {\n  color: #ffffff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n}\n.signIn {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  gap: 16px;\n  margin-top: 8px;\n}\n.signIn p {\n  color: #ffffff;\n  text-align: right;\n  /* font-family: \"Yekan Bakh FaNum\"; */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.tara {\n  border-radius: 12px;\n  background: #480e23;\n  padding: 16px;\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n}\n.taraInfo {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 6px;\n}\n.taraInfo p {\n  color: #fff;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.taraInfo span {\n  font-weight: 600;\n}\n.taraInfo img {\n}\n.taraLink {\n  border-radius: 12px;\n  border: 1px solid #19b16a;\n  background: #fff;\n  padding: 10px 4px 10px 0px;\n  display: flex;\n  padding: 10px 4px 10px 0px;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  align-self: stretch;\n}\n.taraLink span {\n  color: #19b16a;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n@media screen and (min-width: 1000px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `InfoCard_card__aWcER`,
	"cardInner": `InfoCard_cardInner__SMN+y`,
	"login": `InfoCard_login__Hvvpx`,
	"loginNumber": `InfoCard_loginNumber__y3+Iu`,
	"loginChange": `InfoCard_loginChange__svhvW`,
	"title": `InfoCard_title__zxlDV`,
	"signIn": `InfoCard_signIn__0IgU6`,
	"tara": `InfoCard_tara__-oj+g`,
	"taraInfo": `InfoCard_taraInfo__mIWr3`,
	"taraLink": `InfoCard_taraLink__Acr9G`
};
export default ___CSS_LOADER_EXPORT___;
